import { customAxios, IDUSUARIO, FDV_URL } from '../constants';

export default function(idFichaVenta, idsProforma) {
  const promises = [];
  idsProforma.map((id) => {
    const config = {
      headers: {
        idUsuario: IDUSUARIO,
      },
    };
    return promises.push(
      customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/${idFichaVenta}/proforma/${id}/pedidos`, config)
      .then(result => ({ [id]: result.data.estadoTrama === '1' ? result.data.listadoPedidos : [] })
    )
    );
  });
  return Promise.all(promises);
}



// WEBPACK FOOTER //
// ./src/utils/getPedidosPedidos.js